import api from './api';

const reservationService = {
  // Send WhatsApp message for a reservation
  sendWhatsAppMessage: async (reservationId: number, templateId: number): Promise<{ success: boolean; message: string }> => {
    try {
      const response = await api.post(`/reservations/${reservationId}/send_whatsapp/`, {
        template_id: templateId
      });
      return response.data;
    } catch (error) {
      console.error('Error sending WhatsApp message:', error);
      throw error;
    }
  },
};

export default reservationService; 